// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1DiKr","col":"styles_col__vNWQ2","fulfillmentStatus":"styles_fulfillmentStatus__1AO0W","emailCol":"styles_emailCol__-QFXP"};